import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import { Default } from "Types";
import { statuses } from "api";
import { ReduxStates } from "Types";
import { Data as DataType } from "Types/Reducers";
import { actions } from "reducers/redux/data";
import { actions as galleryActions } from "reducers/saga/gallerys";

import AtomPaper from "Components/Atoms/Paper";
// import MoleculeFormText from "Components/Molecules/FormText";

export type PropsType = any;

const Wrap = styled(AtomPaper)`
   margin-top: 5px;
   max-height: 300px;
   overflow-y: scroll;
`;

const Table = styled.table``;

const Td = styled.td<any>`
   cursor: pointer;
   padding: 10px 10px;
   overflow-wrap: break-word;
   word-break: keep-all;
`;

// const FormControlWrap = styled(MoleculeFormText.Wrap)``;

export default function OrganismSearchGallery(props: PropsType) {
   const data = useSelector((state: any) => state.data);
   const resultData = props.data || [];
   const dispatch = useDispatch();
   function dataOnChange(name: any, value: any) {
      dispatch({
         type: actions.set,
         payload: {
            ...data,
            museum: value,
            museum_name: name,
         },
      });
      props.onSelect();
      // dispatch({
      //    type: galleryActions.search.reset,
      // });
   }
   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <Table>
            <tbody>
               {
                  //resultData.status === statuses.resolved &&
                  resultData.map((row: any) => {
                     return (
                        <tr key={row._id}>
                           <Td onClick={() => dataOnChange(row.name, row._id)}>{row._id}</Td>
                           <Td onClick={() => dataOnChange(row.name, row._id)}>{row.name}</Td>
                        </tr>
                     );
                  })
               }
            </tbody>
         </Table>
      </Wrap>
   );
}
